export const API_ROUTES = {
  ANIMALS: "/api/animals",
  CHECKPOINTS: "/api/checkpoints",
  DEVICES: "/api/availableDevices",
  POSITIONS: "/api/animals/position",
  LOGIN: "/api/login",
  REFRESH: "/api/refresh",
};

//export const API_URL = 'http://localhost:5000'

export const API_URL = process.env.VUE_APP_API_URL;
